import { GuiListGeneric } from "../GuiListGeneric";
export class GuiListSupportMandantenLive extends GuiListGeneric {
    constructor() {
        super("MandantenLive");
    }
}
